import request from '../http';

/**
 * 消耗明细报表 API
 * 对接后端 /report/insights
 * 数据来源: ClickHouse fact_insights_daily
 */

/** 按维度聚合查询（不分页，兼容旧接口） */
export const queryInsightsAgg = (params) =>
  request({ url: '/report/insights/agg', method: 'get', params });

/** 按维度聚合查询（分页版）；cancelToken 不入 query，见 getMaterialsForRow */
export const queryInsightsAggPage = (params) => {
  const p = params || {};
  const { cancelToken, ...query } = p;
  return request({
    url: '/report/insights/agg/page',
    method: 'get',
    params: query,
    cancelToken: cancelToken
  });
};

/** 查询每日消耗明细 */
export const queryInsightsDaily = (params) =>
  request({ url: '/report/insights/daily', method: 'get', params });

/** 查询某本书下 ROI 最高的 TOP 20 素材 */
export const queryBookMaterials = (params) =>
  request({ url: '/report/insights/book-materials', method: 'get', params });

/** 导出消耗明细报表 Excel */
export function exportInsightsAgg(params) {
  return request({
    url: '/report/insights/agg/export',
    method: 'get',
    params,
    responseType: 'blob',
    timeout: 120000
  });
}

/** 列出有素材明细的书籍（点击「查看明细」会有数据） */
export const queryBooksWithMaterials = (params) =>
  request({ url: '/report/insights/books-with-materials', method: 'get', params });

/** 创建人下拉选项（sys_user 昵称 + 「其他」） */
export const queryCreatorOptions = () =>
  request({ url: '/report/insights/creator-options', method: 'get' });

/** 回填 fb_campaign.create_user_name（维护用） */
export const backfillCampaignCreateUserName = () =>
  request({ url: '/report/insights/backfill-campaign-create-user-name', method: 'post' });
